import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartChargesIncomesTabPure extends React.Component {
  render() {
    const { data } = this.props;

    // console.log("9 - DATA=", data);
    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "category.categoryFamily.name")}
        // defaultPageSize={computeDefaultTableSize(data, "tiers.name")}
        pivots={["family", "category", "tiers"]}
        showColumns={["family", "category","tiers", "hiddenCommercial"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}
      />
    );
  }
}

export default ChartChargesIncomesTabPure;
